module.exports = __webpack_public_path__ + "img/m-banner-cookagaw-pt-PT.bf862823.jpg";